module.exports = __webpack_public_path__ + "static/media/hands.ccfe15d8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/teachers/noticeboard/hands.svg
// module id = 566
// module chunks = 0